import { LoadingButton } from '@mui/lab';
import { Container, FormControl, Paper, RadioGroup, Stack, Typography } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { presentationServices } from 'src/Services/ApiHandlers/presentationServices';
import classes from './AiPresentation.module.css';

const AiPresentation = () => {
  const [prompt, setPrompt] = useState('');
  const [type, setType] = useState('beamer');
  const [downloadLink, setDownloadLink] = useState('');
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    const content = {
      extera_prompt: prompt,
      book_slug: params.id,
      chapter_slug: params.chapter,
      header_slug: params.header,
      type,
      isHeaderTwo: params.headertwo ? params.headertwo : null,
    };

    setIsLoading(true);
    setDownloadLink('');
    try {
      const response = await presentationServices.createPresentation(content);
      if (response.code === 200) {
        setPrompt('');
        toast.success('Presentation created successfully');
        if (response.data.message) {
          toast.warning(response.data.message);
        }
        setDownloadLink(process.env.REACT_APP_API_IMAGEURL + '/' + response.data.link);
        window.open(process.env.REACT_APP_API_IMAGEURL + '/' + response.data.link, '_blank');
      } else {
        toast.error(response.message || 'Something went wrong');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        mb: '2rem',
        width: '100%',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          margin: '20px 0',
          border: '1px solid #ccc',
        }}
      >
        <Stack
          direction="row"
          sx={{
            width: '100%',
            justifyContent: 'space-between',
            bgcolor: '#0066cc',
            color: 'white',
            padding: '10px 20px',
            borderTopRightRadius: '4px',
            borderTopLeftRadius: '4px',
          }}
        >
          <Typography variant="h5" gutterBottom>
            Creating Slides Using AI
          </Typography>
        </Stack>

        <Stack direction="column" sx={{ p: '2rem' }}>
          <Stack direction="row" sx={{ w: '100%', mb: '1rem' }}>
            <FormControl>
              <RadioGroup
                value={type}
                onChange={(e) => setType(e.target.value)}
                row
                aria-labelledby="type-slide"
                name="type-slide-group"
              >
                <FormControlLabel value="beamer" control={<Radio />} label="Beamer Slides" />
                <FormControlLabel value="powerpoint" control={<Radio />} label="PowerPoint Slides" />
              </RadioGroup>
            </FormControl>
          </Stack>
          <label htmlFor="message" className={classes.label}>
            Prompt:
          </label>
          <textarea
            rows={2}
            placeholder="If left blank, the default prompt will be used."
            className={classes.input_area}
            disabled={isLoading}
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyUp={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                handleSubmit();
              }
            }}
          />
          {downloadLink && (
            <a className={classes.download} href={downloadLink} target="_blank" rel="noreferrer">
              Download Presentation
            </a>
          )}
          <Stack direction="row-reverse">
            <LoadingButton
              sx={{ width: '200px', my: '1rem' }}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              loading={isLoading}
            >
              Submit
            </LoadingButton>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
};

export default AiPresentation;
